"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResourceCalendarModal = void 0;
const firestore_1 = require("firebase/firestore");
const cloneDeep_1 = __importDefault(require("lodash/cloneDeep"));
const isEqual_1 = __importDefault(require("lodash/isEqual"));
const react_1 = __importStar(require("react"));
const Button_1 = __importDefault(require("react-bootstrap/Button"));
const Dropdown_1 = __importDefault(require("react-bootstrap/Dropdown"));
const Form_1 = __importDefault(require("react-bootstrap/Form"));
const Modal_1 = __importDefault(require("react-bootstrap/Modal"));
const configContext_1 = require("../../context/configContext");
const Booking_1 = require("../../models/Booking");
const BookingStatus_1 = require("../../models/BookingStatus");
const CustomerBooking_1 = require("../../models/CustomerBooking");
const bookingFactory = __importStar(require("../../models/helper/bookingFactory"));
const dateUtils = __importStar(require("../../utils/dateUtils"));
const useFirestore_1 = require("../../utils/useFirestore");
const SingleEventCalendar_1 = require("../calendar/SingleEventCalendar");
const ResourceIconWithColor_1 = require("../resource-icon-with-color/ResourceIconWithColor");
const SimpleModal_1 = require("../simple-modal/SimpleModal");
const ResourceCalendarModal = (props) => {
    // Use a copy of the data to enable cancelling.
    const [bookingCopy, setBookingCopy] = (0, react_1.useState)(props.booking);
    const [isValid, setIsValid] = (0, react_1.useState)(false);
    const [busyEvents, setBusyEvents] = (0, react_1.useState)([]);
    const [isBusyEventsLoading, setIsBusyEventsLoading] = (0, react_1.useState)(false);
    const [visibleDates, setVisibleDates] = (0, react_1.useState)();
    const config = (0, configContext_1.useConfig)();
    const firestore = (0, useFirestore_1.useFirestore)();
    /**
     * Load the busy events for the currently visible dates.
     */
    (0, react_1.useEffect)(() => {
        const abortController = new AbortController();
        async function fetchBusyEvents(from, to) {
            setIsBusyEventsLoading(true);
            try {
                // Get from Firestore.
                const bookingSnapshot = await (0, firestore_1.getDocs)((0, firestore_1.query)((0, firestore_1.collection)(firestore, "bookings"), (0, firestore_1.where)("tenantId", "==", config.tenantId), (0, firestore_1.where)("resourceId", "==", bookingCopy.getResourceId()), (0, firestore_1.where)("status", "in", BookingStatus_1.BookingStatus.allBusyStatus.map((s) => s.name)), (0, firestore_1.where)("start", ">", from), (0, firestore_1.where)("start", "<", to), (0, firestore_1.orderBy)("start", "asc"), (0, firestore_1.limit)(40)));
                const bookings = bookingFactory.createAllFromFirestore(bookingSnapshot.docs.filter((bookingDoc) => 
                // Filter the current booking (except if eventKeepSelf is true).
                (props.eventKeepSelf || bookingDoc.id !== bookingCopy.id) &&
                    // Filter cancelled state.
                    bookingDoc.data().status !== BookingStatus_1.BookingStatus.cancelled.name), config);
                const busyEvents = bookings.map((booking) => ({
                    start: booking.start,
                    end: booking.end,
                    title: `${booking.title}` +
                        (booking.subtitle ? ` (${booking.subtitle})` : ""),
                    classNames: ["busy"],
                    rendering: "background",
                }));
                setBusyEvents(busyEvents);
                setIsBusyEventsLoading(false);
            }
            catch (error) {
                if (!abortController.signal.aborted) {
                    throw error;
                }
            }
        }
        if (visibleDates !== undefined) {
            fetchBusyEvents(visibleDates.from, visibleDates.to);
            return () => abortController.abort();
        }
        return undefined;
    }, [visibleDates, bookingCopy.getResourceId()]);
    function handleClose() {
        props.onClose();
    }
    function handleOk(e) {
        e.preventDefault();
        // Test if the user actually made a change.
        if ((0, isEqual_1.default)(props.booking.start, bookingCopy.start) &&
            (0, isEqual_1.default)(props.booking.end, bookingCopy.end) &&
            (0, isEqual_1.default)(props.booking.getResourceId(), bookingCopy.getResourceId())) {
            // No change.
            handleClose();
        }
        else {
            // There was a change. We send the new booking as parameter.
            props.onOk(bookingCopy);
        }
    }
    if (bookingCopy.configResource === undefined) {
        return (react_1.default.createElement(SimpleModal_1.SimpleModal, { className: "resource-calendar-modal-info", title: "\uD83D\uDE2E Leseansicht", body: react_1.default.createElement("p", null, "Leseansicht: Die Ressource kann nicht ge\u00E4ndert werden."), onClose: handleClose }));
    }
    else {
        return (react_1.default.createElement(Modal_1.default, { className: "resource-calendar-modal", show: true, onHide: handleClose, animation: false, centered: true, size: "lg" },
            react_1.default.createElement(Form_1.default, { onSubmit: handleOk, noValidate: true },
                react_1.default.createElement(Modal_1.default.Header, null,
                    react_1.default.createElement(Modal_1.default.Title, { className: "flex-grow-1" },
                        bookingCopy.configResource.resourceItem.type,
                        " ",
                        bookingCopy.configResource.resourceItem.title),
                    config.resources.length > 1 && (react_1.default.createElement(Dropdown_1.default, { alignRight: true, className: "other-resources-dropdown" },
                        react_1.default.createElement(Dropdown_1.default.Toggle, { variant: "outline-secondary", id: "other-resource" }, "Ressource wechseln"),
                        react_1.default.createElement(Dropdown_1.default.Menu, null, config.resources.map((resource) => {
                            if (resource.id !== bookingCopy.getResourceId()) {
                                return (react_1.default.createElement(Dropdown_1.default.Item, { key: resource.id, onClick: () => {
                                        const newBookingCopy = (0, cloneDeep_1.default)(bookingCopy);
                                        newBookingCopy.setResourceId(resource.id);
                                        setBookingCopy(newBookingCopy);
                                    } },
                                    react_1.default.createElement(ResourceIconWithColor_1.ResourceIconWithColor, { resource: resource })));
                            }
                            return undefined;
                        }))))),
                react_1.default.createElement(Modal_1.default.Body, { className: "pb-0" },
                    react_1.default.createElement(SingleEventCalendar_1.SingleEventCalendar, { configResource: bookingCopy.configResource, bookingEvent: bookingCopy, onBookingEventChange: (event) => {
                            const startAndEnd = {
                                start: event.start,
                                end: event.end,
                            };
                            setBookingCopy((prevBookingCopy) => {
                                if (prevBookingCopy instanceof CustomerBooking_1.CustomerBooking) {
                                    return CustomerBooking_1.CustomerBooking.fromPartial(startAndEnd, prevBookingCopy, config);
                                }
                                else {
                                    return Booking_1.Booking.fromPartial(startAndEnd, prevBookingCopy, config);
                                }
                            });
                        }, busyEvents: busyEvents, isBusyEventsLoading: isBusyEventsLoading, visibleDates: visibleDates, onVisibleDatesChange: setVisibleDates, minDate: dateUtils.defaultMinDate, maxDate: dateUtils.defaultMaxDate, isValid: isValid, isValidChange: setIsValid, showWarnings: true, eventTitle: props.eventTitle })),
                react_1.default.createElement(Modal_1.default.Footer, null,
                    react_1.default.createElement(Button_1.default, { type: "submit", variant: "primary", style: { minWidth: "110px" } }, "Ok"),
                    " ",
                    react_1.default.createElement(Button_1.default, { className: "", variant: "secondary", style: { minWidth: "110px" }, onClick: handleClose }, "Schliessen")))));
    }
};
exports.ResourceCalendarModal = ResourceCalendarModal;
